import { User } from "oidc-client-ts";
import { KeycloakProfile } from "../oidcConfig.ts";

export type Role = "manage-filters";

export function hasRole(user: User | undefined | null, role: Role): boolean {
  const profile = user?.profile as unknown as KeycloakProfile;
  return profile?.realm_access?.roles?.includes(role) || false;
}
